// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});
import wixData from 'wix-data';
import wixWindow from 'wix-window';

$w.onReady(function () {

});

export function emailLinkText_click(event) {
    //'Email' is the name of the lightbox to be popped 
    // The second parameter should match the Title row in the Points of Contact table e.g. 'Website Committee'
    wixWindow.openLightbox('Email', 'Private Lesson Subsidy');
}


export function emailLinkText2_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
    wixWindow.openLightbox('Email', 'Newsletter Co-Editors');
}